export default __webpack_public_path__ + "static/media/educational_textile.27373bcb.jpg";